function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.19 11.13c1.81 0 3.28-1.4 3.29-3.12A3.22 3.22 0 007 4.88v1.25h.18c1.08-.01 1.98.83 1.98 1.86A1.92 1.92 0 017 9.87v1.26h.19z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.6 14.6c.08 0 .19.04.25.1.33.33.66.67.97 1.02.24.26.51.35.83.22.57-.22 1.12-.45 1.68-.7.3-.13.43-.37.4-.7l-.09-1.44c0-.07.02-.16.06-.2.15-.18.31-.36.49-.51a.43.43 0 01.26-.11c.5 0 .98.02 1.48.04.28.02.51-.08.66-.33.33-.57.57-1.18.73-1.82.07-.27 0-.5-.22-.7l-.62-.53c-.2-.17-.47-.32-.57-.54-.1-.22-.05-.52-.04-.78 0-.09.05-.2.11-.26l1.06-.98c.23-.2.34-.46.21-.76-.23-.57-.47-1.13-.73-1.68-.14-.3-.4-.42-.74-.39-.28.03-.58.02-.86.07-.52.1-.93-.02-1.23-.46a.28.28 0 00-.07-.06c-.1-.07-.12-.17-.12-.29l.06-1.39a.7.7 0 00-.4-.7A8.36 8.36 0 009.4.02a.69.69 0 00-.76.23l-.89 1a.47.47 0 01-.45.19H7v1.26h.75c.26 0 .46-.08.62-.27l.9-1c.08-.1.15-.13.28-.08.24.11.56.14.7.32.11.16.02.47.01.71 0 .27 0 .53-.03.8a.7.7 0 00.25.58c.33.3.66.63.98.94.15.16.34.21.55.2l1.42-.1c.11 0 .18.03.22.13l.26.6c.05.11.02.18-.06.25-.33.3-.66.61-1 .9a.78.78 0 00-.27.68c.02.4.03.8.02 1.19 0 .26.08.47.27.63l1.03.9c.1.08.1.15.07.26-.17.5-.52.73-1.05.7-.28 0-.55-.01-.83-.03a.71.71 0 00-.57.24l-.95.95a.64.64 0 00-.21.52c.03.47.05.94.09 1.4 0 .14-.04.21-.17.26a7.3 7.3 0 00-.54.23c-.12.06-.2.04-.3-.06l-.9-.95a.82.82 0 00-.73-.28c-.27.03-.54.03-.81.03v1.25c.2-.02.4-.02.6-.01z"
});

var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  width: 7.2,
  height: 14.4,
  y: 1,
  rx: 1
}));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 7.2,
  height: 14.4,
  y: 1,
  stroke: "currentColor",
  strokeWidth: 3,
  mask: "url(#a)",
  rx: 1
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M2.4 5h2.4M2.4 8.2h2.4M2.4 11.4h2.4"
});

function SvgAdministration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministration);
export default __webpack_public_path__ + "static/media/administration.f798441e.svg";
export { ForwardRef as ReactComponent };